import { Loader2, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { BLOCK_LABEL, getBlockTitle } from '../PageListSidebar';
import type { Block } from '@/types';

interface DeletePageDialogProps {
  target: Block | null;
  loading: boolean;
  onOpenChange: (open: boolean) => void;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function DeletePageDialog({ target, loading, onOpenChange, onCancel, onConfirm }: DeletePageDialogProps) {
  return (
    <Dialog open={target !== null} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Pagina verwijderen?</DialogTitle>
          <DialogDescription>
            {target
              ? `Weet je zeker dat je de pagina "${getBlockTitle(target)}" (${BLOCK_LABEL[target.type] || target.type}) wilt verwijderen?`
              : ''}
          </DialogDescription>
        </DialogHeader>
        <div className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2.5 text-sm text-amber-800">
          Je kunt dit ongedaan maken met ⌘Z / Ctrl+Z zolang de editor open is.
        </div>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={onCancel} disabled={loading}>
            Annuleren
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={loading}>
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin mr-1.5" />
                Verwijderen...
              </>
            ) : (
              <>
                <Trash2 className="h-4 w-4 mr-1.5" />
                Pagina verwijderen
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
